import { List } from 'immutable';
import { addToKeyPath, removeEmptyChildGroups } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { getLogicGroupConditionsSize } from '../filterQueryFormat/logic/LogicGroup';
import { And } from '../filterQueryFormat/logic/FilterLogicGroup';
export const initialState = {
  internalDraftValue: undefined,
  internalDraftValueBeforeEdit: undefined,
  externalOriginalValue: undefined,
  isLoadingViewerData: true,
  isLoadingEditorData: false,
  isLoadingFields: false,
  isFieldSelectMode: false,
  selectedObjectType: undefined,
  selectedFilterFamily: undefined,
  selectedFilterFamilyGroup: undefined,
  conditionPathToChangeFieldFor: undefined,
  conditionToRefineKeyPath: undefined,
  draftCondition: undefined,
  selectedCategory: undefined,
  viewerConditionIdToHighlight: undefined,
  viewerConditionToDelete: undefined,
  viewerConditionToDeleteHovered: undefined,
  viewerClonedGroupIndex: undefined,
  viewerFilterSelected: undefined,
  isInEditMode: false,
  isEditorClosed: true,
  isInTestFilters: false,
  testFiltersSelectedObjectId: undefined,
  testFiltersStatus: undefined,
  requiredIdsByAssetFamily: undefined,
  nullValueState: {
    showIncludeObjectsWithNoValueSetByOperator: {},
    defaultNullValueByOperator: {},
    showIncludeObjectsWithNoAssociatedObjectsByFilterBranch: {}
  }
};

// this rule doesn't make sense, sometimes it is needed to define local variable
// inside a `case`
/*    eslint-disable no-case-declarations */

export const utils = {
  addFieldToGroup: (group, payload) => {
    const {
      operator,
      filterFamily
    } = payload;
    const newGroup = addToKeyPath(List(), operator, group, filterFamily);
    return newGroup;
  },
  createBlankAndGroup: filterFamily => {
    return And.of().merge({
      filterFamily
    });
  }
};
const resetFilterFamilySelect = {
  selectedFilterFamily: undefined,
  selectedFilterFamilyGroup: undefined,
  selectedObjectType: undefined,
  conditionToRefineKeyPath: undefined,
  conditionPathToChangeFieldFor: undefined,
  selectedCategory: undefined
};
const resetInternalFilterValue = {
  draftCondition: undefined,
  viewerFilterSelected: undefined
};
export const SegmentationFiltersInstanceReducer = (state, action) => {
  switch (action.type) {
    case 'loadingViewerData':
      return Object.assign({}, state, {
        isLoadingViewerData: action.payload
      });
    case 'loadingEditorData':
      return Object.assign({}, state, {
        isLoadingEditorData: action.payload
      });
    case 'requiredIdsByAssetFamily':
      return Object.assign({}, state, {
        requiredIdsByAssetFamily: action.payload
      });
    case 'internalDraftValue':
      return Object.assign({}, state, {
        internalDraftValue: action.payload
      });
    case 'setCategory':
      return Object.assign({}, state, {
        selectedCategory: action.payload.category,
        selectedFilterFamily: undefined,
        selectedFilterFamilyGroup: undefined
      });
    case 'addFilter':
      {
        const {
          filterFamilyInfo,
          parentGroupKeyPath,
          selectedObjectType
        } = action.payload;
        const internalDraftValue = removeEmptyChildGroups(state.internalDraftValue);
        const newState = Object.assign({}, state, {
          internalDraftValue,
          draftCondition: {
            conditionPath: parentGroupKeyPath,
            filterFamily: filterFamilyInfo ? filterFamilyInfo.filterFamily : undefined,
            isAddingNew: true
          },
          isFieldSelectMode: true,
          isEditorClosed: false
        }, resetFilterFamilySelect, {
          selectedObjectType
        });
        const shouldShowFields = filterFamilyInfo &&
        // this checks if filter family is not an association
        filterFamilyInfo.filterFamily !== selectedObjectType.filterFamily;
        if (shouldShowFields) {
          newState.selectedFilterFamily = filterFamilyInfo;
          newState.isLoadingFields = true;
        }
        return newState;
      }
    case 'cancelAddFilter':
      return Object.assign({}, state, {
        draftCondition: undefined,
        isFieldSelectMode: false,
        selectedCategory: undefined,
        viewerFilterSelected: undefined
      });
    case 'editFilter':
      {
        const internalDraftValue = removeEmptyChildGroups(state.internalDraftValue);
        return Object.assign({}, state, {
          internalDraftValue,
          draftCondition: {
            conditionPath: action.payload.conditionPath,
            filterFamily: action.payload.filterFamily,
            isAddingNew: false
          },
          isFieldSelectMode: false,
          viewerConditionToDelete: undefined,
          isEditorClosed: false
        });
      }
    case 'addFilterGroup':
      {
        const filterFamily = action.payload;
        const newFilterGroup = utils.createBlankAndGroup(filterFamily);
        const internalDraftValue = addToKeyPath(List(), newFilterGroup, state.internalDraftValue, action.payload);
        const numberOfTopLevelGroups = state.internalDraftValue && getLogicGroupConditionsSize(state.internalDraftValue) || 0;
        const conditionPath = List([numberOfTopLevelGroups]);
        const internalDraftValueBeforeEdit = !state.isInEditMode ? state.internalDraftValue : state.internalDraftValueBeforeEdit;
        return Object.assign({}, state, {
          isFieldSelectMode: true,
          isInEditMode: true,
          isEditorClosed: false,
          draftCondition: {
            conditionPath,
            filterFamily: undefined,
            isAddingNew: true
          },
          internalDraftValue,
          internalDraftValueBeforeEdit
        }, resetFilterFamilySelect, {
          selectedObjectType: {
            filterFamily,
            isObjectOwnFilterBranch: true
          }
        });
      }
    case 'selectField':
      return Object.assign({}, state, {
        isFieldSelectMode: false,
        internalDraftValue: action.payload.internalDraftValue,
        draftCondition: {
          conditionPath: action.payload.conditionPath,
          filterFamily: action.payload.filterFamily,
          isAddingNew: false
        }
      }, resetFilterFamilySelect, {
        conditionPathToChangeFieldFor: undefined,
        selectedCategory: undefined
      });
    case 'fieldSelectMode':
      return Object.assign({}, state, {
        isFieldSelectMode: action.payload
      }, resetFilterFamilySelect);
    case 'resetEditor':
      {
        const internalDraftValue = action.payload && action.payload.internalDraftValue ? action.payload.internalDraftValue : state.internalDraftValue;
        const isInEditMode = action.payload && action.payload.shouldLeaveEditorOpen || false;
        const internalDraftValueBeforeEdit = isInEditMode ? state.internalDraftValueBeforeEdit : undefined;
        return Object.assign({}, state, {
          isFieldSelectMode: false,
          viewerConditionToDelete: undefined,
          isInEditMode,
          internalDraftValue,
          internalDraftValueBeforeEdit
        }, resetInternalFilterValue, resetFilterFamilySelect);
      }
    case 'nullValueState':
      return Object.assign({}, state, {
        nullValueState: action.payload
      });
    case 'refineFilter':
      return Object.assign({}, state, {
        isFieldSelectMode: true,
        conditionToRefineKeyPath: action.payload.conditionToRefineKeyPath,
        selectedFilterFamily: action.payload.filterFamilyInfo,
        isLoadingFields: true
      });
    case 'filterFamily':
      return Object.assign({}, state, {
        selectedFilterFamily: action.payload.filterFamilyInfo,
        isLoadingFields: true
      });
    case 'filterFamilyGroup':
      return Object.assign({}, state, {
        selectedFilterFamilyGroup: action.payload.filterFamilyGroup
      });
    case 'fieldsLoaded':
      return Object.assign({}, state, {
        isLoadingFields: false
      });
    case 'viewerDeleteCondition':
      return Object.assign({}, state, {
        internalDraftValue: action.payload.internalDraftValue,
        viewerConditionToDelete: undefined
      });
    case 'viewerConditionToDelete':
      return Object.assign({}, state, {
        viewerConditionToDelete: action.payload
      });
    case 'viewerConditionToDeleteHovered':
      return Object.assign({}, state, {
        viewerConditionToDeleteHovered: action.payload
      });
    case 'viewerClonedGroupIndex':
      const internalDraftValue = action.payload && action.payload.internalDraftValue ? action.payload.internalDraftValue : state.internalDraftValue;
      const viewerClonedGroupIndex = action.payload ? action.payload.viewerClonedGroupIndex : undefined;
      return Object.assign({}, state, {
        viewerClonedGroupIndex,
        internalDraftValue,
        isFieldSelectMode: false
      }, resetFilterFamilySelect, resetInternalFilterValue);
    case 'viewerConditionIdToHighlight':
      return Object.assign({}, state, {
        viewerConditionIdToHighlight: action.payload
      });
    case 'changeField':
      return Object.assign({}, state, {
        selectedFilterFamily: action.payload.filterFamilyInfo,
        conditionPathToChangeFieldFor: action.payload.conditionPath,
        isFieldSelectMode: true,
        isLoadingFields: true
      });
    case 'deleteCondition':
      return Object.assign({}, state, {
        isFieldSelectMode: false,
        viewerConditionToDelete: undefined,
        internalDraftValue: action.payload.internalDraftValue
      }, resetInternalFilterValue, resetFilterFamilySelect);
    case 'editFilters':
      return Object.assign({}, state, {
        isInEditMode: true,
        isEditorClosed: false,
        internalDraftValueBeforeEdit: state.internalDraftValue
      });
    case 'hideEditor':
      return Object.assign({}, state, resetInternalFilterValue, {
        isEditorClosed: true
      });
    case 'externalOriginalValue':
      return Object.assign({}, state, {
        externalOriginalValue: action.payload
      });
    case 'discardChanges':
      return Object.assign({}, state, {
        isFieldSelectMode: false,
        viewerConditionToDelete: undefined,
        isInEditMode: false,
        internalDraftValue: state.internalDraftValueBeforeEdit,
        internalDraftValueBeforeEdit: undefined
      }, resetInternalFilterValue, resetFilterFamilySelect);
    case 'resetSelectedFilterCategory':
      if (action.payload && action.payload.resetSelectedFilterCategoryGroup) {
        return Object.assign({}, state, {
          selectedFilterFamily: undefined,
          selectedFilterFamilyGroup: undefined
        });
      }
      return Object.assign({}, state, {
        selectedFilterFamily: undefined
      });
    case 'viewerFilterSelected':
      return Object.assign({}, state, {
        viewerFilterSelected: action.payload
      });
    case 'showTestFilters':
      return Object.assign({}, state, {
        isInTestFilters: true
      });
    case 'hideTestFilters':
      return Object.assign({}, state, {
        isInTestFilters: false,
        testFiltersStatus: undefined
      });
    case 'testFiltersObjectChanged':
      return Object.assign({}, state, {
        testFiltersSelectedObjectId: action.payload
      });
    case 'onTestFiltersUpdated':
      return Object.assign({}, state, {
        testFiltersStatus: action.payload
      });
    case 'selectedObjectType':
      return Object.assign({}, state, resetFilterFamilySelect, {
        selectedObjectType: action.payload
      });
    default:
      throw new Error(`No ${action.type} in the SegmentationFiltersInstanceReducer`);
  }
};